<template>
  <v-dialog v-model="show" width="40vw" scrollable>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"> Guía de muestras </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="guideForm">
            <v-row no-gutters>
              <v-col cols="1">
                <v-icon @click="copyText">mdi-content-copy</v-icon>
              </v-col>
              <v-col cols="10">
                <v-text-field
                  outlined
                  label="Número de guia"
                  dense
                  type="text"
                  v-model="trackingNumber"
                  clearable
                  :disabled="!showUpdateGuide"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  label="Nombre paquetería"
                  outlined
                  dense
                  clearable
                  :items="guidesCompanies"
                  v-model="guideCompany"
                  :disabled="!showUpdateGuide || !trackingNumber"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" v-if="isDealership">
                <v-text-field
                  outlined
                  label="Fecha de entrega a concesionaria"
                  dense
                  type="date"
                  clearable
                  :disabled="!showUpdateGuide"
                  :rules="[fechaActual]"
                  v-model="dealershipDate"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  label="Fecha de envió de kit"
                  dense
                  type="date"
                  clearable
                  :rules="[fechaActual]"
                  :disabled="!showUpdateGuide"
                  v-model="sendDate"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  label="Fecha de entrega de kit"
                  dense
                  type="date"
                  clearable
                  :disabled="!showUpdateGuide"
                  :rules="[fechaActual]"
                  v-model="receivedDate"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="isDealership"
                  :disabled="!showUpdateGuide"
                  label="Aplica fecha concesionaria"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="gray"
                dark
                block
                @click="show = false"
                :disabled="isLoading"
              >
                Cerrar
              </v-btn>
            </v-col>
            <v-col v-if="showUpdateGuide">
              <v-btn
                color="primary"
                block
                @click="addTrackingData"
                :loading="isLoading"
              >
                Actualizar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import { requiredValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    trackingNumber: null,
    sendDate: null,
    receivedDate: null,
    dealershipDate: null,
    isDealership: false,
    isLoading: false,
    guidesCompanies: ["DHL", "Estafeta", "PaqueteExpress", "Fedex"],
    guideCompany: null,
  }),
  props: {
    value: Boolean,
  },
  mounted() {
    if (this.guideSelected) {
      if (this.guideSelected.trackingNumber) {
        this.trackingNumber = this.guideSelected.trackingNumber;
      }
      if (this.guideSelected.sendDate) {
        this.sendDate = this.guideSelected.sendDate;
      }
      if (this.guideSelected.receivedDate) {
        this.receivedDate = this.guideSelected.receivedDate;
      }
      if (this.guideSelected.dealershipDate) {
        this.dealershipDate = this.guideSelected.dealershipDate;
      }
      if (this.guideSelected.isDealership) {
        this.isDealership = this.guideSelected.isDealership;
      }
      if (this.guideSelected.shipmentCompany) {
        this.guideCompany = this.guideSelected.shipmentCompany;
      }
    }
  },
  computed: {
    ...mapState("reception", ["guideSelected", "showUpdateGuide"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("reception", ["addTrackingShipmentInformation"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("reception", ["SET_GUIDE"]),
    validation(name) {
      return requiredValidation(name);
    },
    async addTrackingData() {
      if (this.$refs.guideForm.validate()) {
        try {
          this.isLoading = true;
          let response = await this.addTrackingShipmentInformation({
            shipmentId: this.guideSelected._id,
            trackingNumber: this.trackingNumber,
            sendDate: this.sendDate,
            receivedDate: this.receivedDate,
            dealershipDate: this.dealershipDate,
            isDealership: this.isDealership,
            shipmentCompany: this.guideCompany,
          });
          if (response) {
            if (!response.error) {
              this.$emit("updateTable");
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "Información actualizada",
                timeout: 5000,
              });
              this.show = false;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: "Algo salio mal al guardar información, intente de nuevo!!",
                timeout: 5000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al guardar información, intente de nuevo!!",
              timeout: 5000,
            });
          }
        } catch (error) {
          console.log(error);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Algo salio mal al guardar información, intente de nuevo!!",
            timeout: 5000,
          });
        }
        this.isLoading = false;
      }
    },
    copyText() {
      navigator.clipboard.writeText(this.trackingNumber);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "success",
        text: "Número de guia copiado",
        timeout: 5000,
      });
    },
    fechaActual(value) {
      // Si el valor es nulo o vacío, la validación pasa sin problemas
      if (!value) {
        return true;
      }

      // Validar que el año corresponda al año actual
      const fechaSeleccionada = new Date(value);
      const añoActual = new Date().getFullYear();
      if (fechaSeleccionada.getFullYear() !== añoActual) {
        return "La fecha debe ser del año actual";
      }

      // La fecha es válida
      return true;
    },
  },
  watch: {
    // show(value) {
    //   if (value) {
    //     // DIALOG OPEN
    //     if (this.guideSelected) {
    //       if (this.guideSelected.trackingNumber) {
    //         this.trackingNumber = this.guideSelected.trackingNumber;
    //       }
    //       if (this.guideSelected.sendDate) {
    //         this.sendDate = this.guideSelected.sendDate;
    //       }
    //       if (this.guideSelected.receivedDate) {
    //         this.receivedDate = this.guideSelected.receivedDate;
    //       }
    //       if (this.guideSelected.dealershipDate) {
    //         this.dealershipDate = this.guideSelected.dealershipDate;
    //       }
    //       if (this.guideSelected.isDealership) {
    //         this.isDealership = this.guideSelected.isDealership;
    //       }
    //     }
    //   } else {
    //     // DIALOG CLOSE
    //     this.trackingNumber = null;
    //     this.sendDate = null;
    //     this.receivedDate = null;
    //     this.dealershipDate = null;
    //     this.isDealership = false;
    //     this.isLoading = false;
    //     this.SET_GUIDE(null);
    //   }
    // },
    trackingNumber(value) {
      if (!this.guideSelected.shipmentCompany) {
        if (value.toString().startsWith("77")) {
          this.guideCompany = "Fedex";
        } else if (value.length == 13) {
          this.guideCompany = "PaqueteExpress";
        } else if (value.length == 10) {
          this.guideCompany = "Estafeta";
        }
      }
    },
    isDealership(value) {
      if (!value) {
        this.dealershipDate = null;
      }
    },
  },
};
</script>
